module.exports = __webpack_public_path__ + "static/img/to_video_bg.5d0600a0.png";